// Temporary feature switch for the Habarlar section.
// Set HABARLAR to true to restore all Habarlar entry points and routes.
const FEATURE_FLAGS = Object.freeze({
  HABARLAR: false,
});

const PAYMENT_METHODS = [
  {
    value: 0,
    label: {
      tk: 'Nagt',
      ru: 'Nalichka',
    },
  },
  {
    value: 1,
    label: {
      tk: 'Terminal',
      ru: 'Terminal',
    },
  },
];

const DELIVERY_TYPES = [
  {
    value: 0,
    label: {
      tk: 'Delivery',
      ru: 'Dostawka',
    },
  },
  {
    value: 1,
    label: {
      tk: 'Express delivery',
      ru: 'Express dostawka',
    },
  },
  {
    value: 2,
    label: {
      tk: 'Baryp almak',
      ru: 'Na hodu',
    },
  },
];
const MYPUBLICATION_STATUSES = {
  0: {
    value: 0,
    label: {
      tk: 'Kabul edilmedi',
      ru: 'Отклонён',
    },
    class: 'text-red-500',
  },
  1: {
    value: 1,
    label: {
      tk: 'Garaşylýar (Täze)',
      ru: 'Ожидается (Новый)',
    },
    class: 'text-amber-400',
  },
  2: {
    value: 2,
    label: {
      tk: 'Garaşylýar (Düzediş)',
      ru: 'Ожидается (Редактирование)',
    },
    class: 'text-amber-400',
  },
};

const SORT_OPTIONS = [
  {
    name: {
      tk: 'Hödürlenen tertipde',
      ru: 'По умолчанию',
      en: 'By relevancy',
    },
    value: null,
  },

  {
    name: {
      tk: 'Gymmatdan - arzana',
      ru: 'Цена (по убыванию)',
      en: 'Price descending',
    },
    value: '-price',
  },
  {
    name: {
      tk: 'Arzandan - gymmada',
      ru: 'Цена (по возрастанию)',
      en: 'Price ascending',
    },
    value: 'price',
  },
];

const SPLIDE_PILL_OPTIONS = {
  pagination: false,
  perMove: 1,
  gap: '1rem',
  autoWidth: true,
  arrows: false,
  drag: 'free',
};
const CONTACT_TYPE_OPTIONS = {
  0: 'Mail',
  2: 'IMO',
  3: 'Website',
  4: 'Instagram',
  5: 'TikTok',
  6: 'YouTube',
};

const LINK_TYPE = {
  1: {
    type: 1,
    route: 'storeDetail',
    hasOptions: false,
  },
  2: {
    type: 2,
    route: 'storeProductDetail',
    hasOptions: false,
  },
  3: {
    type: 3,
    route: 'foodRestaurantDetail',
    hasOptions: false,
  },
  4: {
    type: 4,
    route: 'foodRestaurantProductDetail',
    hasOptions: false,
  },
  5: {
    type: 5,
    route: 'adAccount',
    hasOptions: false,
  },
  6: {
    type: 6,
    route: 'businessAccountsDetail',
    hasOptions: false,
  },
  7: {
    type: 7,
    route: 'newsDetail',
    hasOptions: false,
  },
  8: {
    type: 8,
    route: 'brandProducts',
    hasOptions: false,
  },
  9: {
    type: 9,
    route: 'publicationDetail',
    hasOptions: false,
  },
  10: {
    type: 10,
    route: 'publications',
    hasOptions: true,
  },
  11: {
    type: 11,
    route: 'stores',
    hasOptions: true,
  },
  12: {
    type: 12,
    route: 'foodRestaurants',
    hasOptions: true,
  },
  13: {
    type: 13,
    route: 'products',
    hasOptions: true,
  },
  14: {
    type: 14,
    route: 'foods',
    hasOptions: true,
  },
};

const POPUP_TYPE = {
  WEB_PUBLICATIONS: 100,
  WEB_MALL: 101,
  WEB_MEDIA: 102,
  WEB_RESTAURANT: 103,
};

export {
  FEATURE_FLAGS,
  PAYMENT_METHODS,
  DELIVERY_TYPES,
  MYPUBLICATION_STATUSES,
  SORT_OPTIONS,
  SPLIDE_PILL_OPTIONS,
  CONTACT_TYPE_OPTIONS,
  LINK_TYPE,
  POPUP_TYPE,
};
